import React, { useState, useEffect } from 'react'
import { ACTION } from 'consts/index'
import { useDispatch } from 'react-redux'
import { TIME_SLOTS } from 'consts'
//antd
import { Input, Button, Row, notification, Modal, Form, Select, InputNumber, Col } from 'antd'

//apis
import { addRegion, updateRegion } from 'apis/region'

export default function RegionForm({ reloadData, children, infoRegion, countries = [] }) {
  const dispatch = useDispatch()
  const [form] = Form.useForm()

  const [visible, setVisible] = useState(false)
  const [timeBlocks, setTimeBlocks] = useState(Array(7).fill({
    open: '',
    close: ''
  }))
  const [timeSlots, setTimeSlots] = useState([])
  const [monOpen, setMonOpen] = useState(null)
  const [monClose, setMonClose] = useState(null)
  const [tueOpen, setTueOpen] = useState(null)
  const [tueClose, setTueClose] = useState(null)
  const [wedOpen, setWedOpen] = useState(null)
  const [wedClose, setWedClose] = useState(null)
  const [thuOpen, setThuOpen] = useState(null)
  const [thuClose, setThuClose] = useState(null)
  const [friOpen, setFriOpen] = useState(null)
  const [friClose, setFriClose] = useState(null)
  const [satOpen, setSatOpen] = useState(null)
  const [satClose, setSatClose] = useState(null)
  const [sunOpen, setSunOpen] = useState(null)
  const [sunClose, setSunClose] = useState(null)

  const _addOrUpdateRegion = async () => {
    try {
      await form.validateFields()
      const formData = form.getFieldsValue()
      dispatch({ type: ACTION.LOADING, data: true })

      const body = { ...formData,
         country_id: formData.country_id || 'vn',
        opening_data : timeBlocks, 
      }

      let res
      if (infoRegion) res = await updateRegion(infoRegion.region_id, body)
      else res = await addRegion(body)
      console.log(res)
      if (res.status === 200) {
        if (res.data.success) {
          reloadData()
          notification.success({
            message: `${infoRegion ? 'Cập nhật' : 'Tạo'} khu vực thành công`,
          })
          setVisible(false)
        } else
          notification.error({
            message:
              res.data.message ||
              `${infoRegion ? 'Cập nhật' : 'Tạo'} khu vực thất bại, vui lòng thử lại!`,
          })
      } else
        notification.error({
          message:
            res.data.message ||
            `${infoRegion ? 'Cập nhật' : 'Tạo'} khu vực thất bại, vui lòng thử lại!`,
        })
      dispatch({ type: ACTION.LOADING, data: false })
    } catch (error) {
      console.log(error)
      dispatch({ type: ACTION.LOADING, data: false })
    }
  }


  const _getTimesSlot = async (query) => {
    try {
      let _timeSlots = TIME_SLOTS.filter((val) => val.disabled == false);
      setTimeSlots(_timeSlots);
    } catch (error) {
      console.log(error)
    }

    
  }

  const setTimeOpen = (val,index ) => {
    // console.log("setTimeOpen");
    // setText('');
    timeBlocks[index]= {
      open : val,
      close : timeBlocks[index].close
    };
    // if(index ==0) {
    //   setMondayOpen(val);
    // }
    setTimeBlocks(timeBlocks);
    // setText('hello');
    // console.log("setTimeOpen");
    switch(index) {
      case 0:
        setMonOpen(val);
        break;
      case 1:
        setTueOpen(val);
        break;
      case 2:
        setWedOpen(val);
        break;
      case 3:
        setThuOpen(val);
        break;
      case 4:
        setFriOpen(val);
        break;
      case 5:
        setSatOpen(val);
        break;
      case 6:
        setSunOpen(val);
        break;     
    }

  }

  const setTimeClose = (val,index ) => {
    // setText('');
    timeBlocks[index]= {
      open : timeBlocks[index].open,
      close : val
    };
    // // // setTimeBlocks(timeBlocks);
    // setText('hello');
    setTimeBlocks(timeBlocks);
    switch(index) {
      case 0:
        setMonClose(val);
        break;
      case 1:
        setTueClose(val);
        break;
      case 2:
        setWedClose(val);
        break;
      case 3:
        setThuClose(val);
        break;
      case 4:
        setFriClose(val);
        break;
      case 5:
        setSatClose(val);
        break;
      case 6:
        setSunClose(val);
        break;     
    }
  }

  const buildRowOpenAndClose = (index, valueOpen, valueClose ) => {
    return <>
      <Row>
                  <div>{ buildTitle(index) }</div>
              </Row>
              <Row>
                  <Col md={10}>
                  <Select 
                     placeholder="Chọn thời gian mở" onChange={(val)=> {
                        setTimeOpen(val, index)
                      }} style={{ width: '100%' }}
                      value={valueOpen}
                      >
                      {timeSlots.map((timeSlot) => (
                        <Select.Option value={timeSlot.value} key={timeSlot.value + '_open_' + 0}>
                            {timeSlot.name}
                        </Select.Option>
                      ))}
                  </Select>
                  </Col>
                  <Col md={2} style={{textAlign:'center'}}>
                  ~
                  </Col>
                  <Col md={10}>
                  <Select name={('close' + 0)} placeholder="Chọn thời gian đóng" onChange={(val)=> {
                    setTimeClose(val, index)
                  }}
                      style={{ width: '100%' }}
                      value={valueClose}
                      >
                      {timeSlots.map((timeSlot) => (
                      <Select.Option value={timeSlot.value} key={timeSlot.value + '_close_' + 0}>
                          {timeSlot.name}
                      </Select.Option>
                      ))}
                  </Select>
                  </Col>
              </Row>
    </>;
  }

  useEffect(()=> {
    _getTimesSlot();
  },[])

  const buildTitle = (index) =>{
    return (index == 6 ? 'Chủ nhật' :'Thứ ' + (Number(index)+2));
  }
  
  useEffect(()=> {
    console.log("infoRegion", infoRegion);
    if(infoRegion && infoRegion.opening_data) {
      setTimeBlocks(infoRegion.opening_data);
      setMonOpen(infoRegion.opening_data[0].open);
      setMonClose(infoRegion.opening_data[0].close);

      setTueOpen(infoRegion.opening_data[1].open);
      setTueClose(infoRegion.opening_data[1].close);

      setWedOpen(infoRegion.opening_data[2].open);
      setWedClose(infoRegion.opening_data[2].close);

      setThuOpen(infoRegion.opening_data[3].open);
      setThuClose(infoRegion.opening_data[3].close);  
      
      setFriOpen(infoRegion.opening_data[4].open);
      setFriClose(infoRegion.opening_data[4].close);  

      setSatOpen(infoRegion.opening_data[5].open);
      setSatClose(infoRegion.opening_data[5].close);  

      setSunOpen(infoRegion.opening_data[6].open);
      setSunClose(infoRegion.opening_data[6].close); 
    }
  },[infoRegion])

  //reset
  useEffect(() => {
    if (!visible) {
      form.resetFields()
    } else {
      if (infoRegion) {
        form.setFieldsValue({ ...infoRegion })
      }
    }
  }, [visible])

  return (
    <>
      <div onClick={() => setVisible(true)}>{children}</div>
      <Modal
        title={infoRegion ? 'Cập nhật khu vực' : 'Thêm khu vực'}
        style={{ top: 20 }}
        width={850}
        footer={null}
        visible={visible}
        onCancel={() => setVisible(false)}
      >
        <Form form={form} layout="vertical">
          <Row justify="space-between" align="middle">
            <Form.Item
              name="name"
              label="Tên khu vực"
              rules={[{ required: true, message: 'Vui lòng nhập tên khu vực!' }]}
            >
              <Input
                allowClear
                size="large"
                style={{ width: 350 }}
                placeholder="Nhập tên khu vực"
              />
            </Form.Item>
            <Form.Item
              name="country_id"
              label="Quốc gia"
              rules={[{ required: true, message: 'Vui lòng chọn quốc gia!' }]}
            >
              <Select
                allowClear
                showSearch
                optionFilterProp="children"
                style={{ width: 350 }}
                size="large"
                placeholder="Chọn mã quốc gia"
              >
                {countries.map((country, index) => (
                  <Select.Option value={country.country_id} key={index}>
                    <Row wrap={false} align="middle">
                      <img
                        src={country.image_url}
                        alt=""
                        style={{ width: 20, height: 20, marginRight: 10 }}
                      />
                      {country.name}
                    </Row>
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Col md={24}>
              <Row>
                <div>Thời gian mở/đóng cửa</div>
              </Row>
              

              {buildRowOpenAndClose(0, monOpen, monClose)}
              {buildRowOpenAndClose(1, tueOpen, tueClose)}
              {buildRowOpenAndClose(2, wedOpen, wedClose)}
              {buildRowOpenAndClose(3, thuOpen, thuClose)}
              {buildRowOpenAndClose(4, friOpen, friClose)}
              {buildRowOpenAndClose(5, satOpen, satClose)}
              {buildRowOpenAndClose(6, sunOpen, sunClose)}
          
            </Col>
            <Form.Item
              name="lat"
              label="Lat"
              rules={[{ required: true, message: 'Vui lòng nhập lat' }]}
            >
              <InputNumber style={{ width: 350 }} placeholder="Nhập lat" size="large" />
            </Form.Item>
            <Form.Item
              name="lng"
              label="Lng"
              rules={[{ required: true, message: 'Vui lòng nhập lng' }]}
            >
              <InputNumber style={{ width: 350 }} placeholder="Nhập lng" size="large" />
            </Form.Item>
            <Form.Item initialValue="" label="Ưu tiên hiển thị" name="priority">
              <Input
                allowClear
                size="large"
                style={{ width: '100%' }}
                placeholder="Nhập số ưu tiên"
              />
            </Form.Item>
          </Row>
          
        </Form>
        <div>
          <h3>Hướng dẫn lấy vị trí vĩ độ latitude và vị trí kinh độ longitude</h3>
          <div>
            - Vào Google Map tại địa chỉ{' '}
            <a href="https://www.google.com/maps" target="_blank">
              https://www.google.com/maps
            </a>{' '}
            để bắt đầu lấy kinh độ và vĩ độ.
          </div>
          <div>
            - Click chuột phải vào vị trí bất kì trên bản đồ, lúc này sẽ xuất hiện lat, lng cần lấy
            <Row justify="center">
              <img
                style={{ width: 350, height: 350 }}
                src="https://s3.ap-northeast-1.wasabisys.com/admin-order/2022/06/21/5d4acf25-2172-4d13-879e-47517a479efa/photo_2022-06-21_20-03-08.jpg"
                alt=""
              />
            </Row>
          </div>
        </div>
        <Row justify="end">
          <Button size="large" type="primary" onClick={_addOrUpdateRegion}>
            {infoRegion ? 'Cập nhật' : 'Thêm'}
          </Button>
        </Row>
      </Modal>
    </>
  )
}
